import { useState } from 'react';
import { useDispatch } from 'react-redux';

import api from '../../../api';
import notifSystem from '../../../notifSystem';
import { saveInterPaiement } from '../../../actions/compta';
import { closeDialog } from '../../../actions/dialog';

const usePayment = (initialData = {}, initialArtisan, onSave) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(initialData);
  const [artisan] = useState(initialArtisan);
  const [save, setSave] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updateIntervention, setUpdateIntervention] = useState(false);
  const [openSecDialog, setOpenSecDialog] = useState(false);
  const [conflictObj, setConflictObj] = useState(null);
  const [statusRemuneration, setStatusRemuneration] = useState(
    (initialData.remunerationArtisan || {}).status ||
    (initialArtisan?.remuneration?.status)
  );

  const close = () => dispatch(closeDialog());

  const onValidate = () => setSave(true);

  const onReject = () => close();

  const finishLoading = () => setLoading(false);

  const setRem = (e) => setStatusRemuneration(e.target.value);

  const setInter = (path, value, cb = f => f) => {
    setData(prev => {
      const next = { ...prev, [path]: value };
      cb(next);
      return next;
    });
    setUpdateIntervention(true);
  };

  const setComments = (v) => {
    if (v !== null) {
      setData(prev => ({ ...prev, comments: v.toJS() }));
    }
  };

  const confiltCheck = (message, obj) => {
    if (message === 'Conflict') {
      setOpenSecDialog(true);
      setSave(false);
      setConflictObj(obj);
      setVisible(false);
    } else {
      setVisible(false);
      notifSystem.error('Erreur', 'Le paiement n\'a pas été enregistrée');
    }
  };

  const sendPayement = async (methods, ...params) => {
    try {
      setVisible(true);
      await api.paiements[methods](...params);
      if (updateIntervention) {
        await saveInterPaiement(data);
      }
      if (onSave) {
        onSave();
      }
      close();
      return notifSystem.success('Message', 'Informations sauvegardées');
    } catch (e) {
      return confiltCheck(e.message, {
        ...(params[1] || params[0]),
        _id: params[1] ? params[0] : null,
      });
    }
  };

  const changeMethods = (modeToCheck) => {
    const toSend = { ...conflictObj, _id: undefined, modeToCheck };
    if (conflictObj._id) {
      return sendPayement('patch', conflictObj._id, toSend);
    }
    return sendPayement('post', toSend);
  };

  return {
    data,
    artisan,
    save,
    visible,
    loading,
    openSecDialog,
    statusRemuneration,
    onValidate,
    onReject,
    finishLoading,
    setRem,
    setInter,
    setComments,
    sendPayement,
    changeMethods,
  };
};

export default usePayment;
